import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export interface ParticipantTabState {
  menuType: string;
  toggleLoader: boolean;
  assignable: boolean;
}

const initialState: ParticipantTabState = {
  menuType: "",
  toggleLoader: false,
  assignable: false,
};

const getIntialState = (): ParticipantTabState => {
  const menuType = sessionStorage?.getItem("menu-type") ?? "";
  return {
    ...initialState,
    menuType,
  };
};

export const participantTabSlice = createSlice({
  name: "participantTab",
  initialState: getIntialState(),
  reducers: {
    setTabMenuType: (state, action: PayloadAction<string>) => {
      state.menuType = action.payload;
    },
    setToggleLoader: (state) => {
      state.toggleLoader = !state.toggleLoader;
    },
    setParticipantAssignable: (state, action: PayloadAction<boolean>) => {
      state.assignable = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setTabMenuType,
  setToggleLoader,
  setParticipantAssignable,
  reset,
} = participantTabSlice.actions;

export default participantTabSlice.reducer;
